/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconMirror: {
  name: 'mirror';
  data: string;
} = {
  name: 'mirror',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M489.89 77.128h-20.868C422.465 36.686 367.35 13.192 308.004 13.192c-59.347 0-114.461 23.494-161.019 63.936H126.12V539.26h20.516c46.622 40.549 101.963 64.261 161.368 64.261S422.75 579.81 469.372 539.26h20.518V77.128zm-331.495 34.779H334.2L158.614 262.409v75.393l263.545-225.895h35.565v393.478H158.395V111.907z"/><path d="M158.614 505.345 195.611 505.345 457.394 281.261 457.394 149.324 457.394 149.32 158.614 405.518z"/></svg>`,
};
